import { can, type Permission } from "@cva/shared";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import { orpc } from "./api";

export function useOrgId(): string {
  const { orgId } = useParams({ strict: false }) as { orgId?: string };
  if (!orgId) throw new Error("useOrgId außerhalb einer Organisation");
  return orgId;
}

/**
 * Current role in the organization, and a permission check helper. Without a
 * running subscription the organization is read-only (docs/16-geschaeftsmodell.md).
 */
export function useOrgRole(orgId: string) {
  const { data } = useQuery(orpc.orgs.list.queryOptions());
  const org = data?.find((item) => item.id === orgId);
  const role = org?.role ?? null;
  const readOnly = org?.readOnly ?? false;
  return { role, readOnly, can: (permission: Permission) => can(role, permission, readOnly) };
}
